const search = async ({ query, type, signal }) => {
    const params = {
        q: query,
    };

    if (type.length > 0) {
        params.type = type;
        params.archived = false;
        params.limit = 50;
    }

    const searchResult = await ApiClient.get(
        '/search',
        {
            ...params,
        },
        signal,
    );

    if (searchResult && searchResult.data.data.length !== 0) {
        return { ...searchResult, is_similar_results: false };
    } else {
        const similarSearchResult = await ApiClient.get(
            '/search/similar-results',
            {
                ...params,
            },
            signal,
        );
        return { ...similarSearchResult, is_similar_results: true };
    }
};

const companyScan = (query, countryCode) => {
    return ApiClient.get('/companies/scan/search', {
        countryCode,
        q: query,
    });
};

export { search, companyScan };
